import '../../../stylesheets/savvy/contents'
import '../../../stylesheets/savvy/company'
import '../../../stylesheets/savvy/company_list'
import '../../../stylesheets/savvy/news'
import '../../../stylesheets/savvy/privacy'
import '../../../stylesheets/savvy/sitemap'
import '../../../stylesheets/savvy/common'
import '../../../stylesheets/savvy/blue/contents'
import '../../../stylesheets/savvy/blue/company'
import '../../../stylesheets/savvy/blue/company_list'
import '../../../stylesheets/savvy/blue/news'
import '../../../stylesheets/savvy/blue/privacy'
import '../../../stylesheets/savvy/blue/sitemap'
import '../../../stylesheets/savvy/blue/common'
import '../application'
